(() => {
  const header = document.querySelector("[data-header]");

  if (!header) {
    return;
  }

  const menuButton = header.querySelector("[data-header-menu]");
  const drawer = header.querySelector("[data-header-drawer]");
  const panel = drawer ? drawer.querySelector(".header__drawer-panel") : null;
  const closeButtons = drawer ? header.querySelectorAll("[data-header-drawer-close]") : [];
  const drawerLinks = drawer ? drawer.querySelectorAll(".header__drawer-link, .header__drawer-sublink") : [];
  const submenuToggles = drawer ? drawer.querySelectorAll("[data-drawer-submenu-toggle]") : [];
  const desktopItems = header.querySelectorAll(".header__nav-item--has-children");
  const mobileQuery = window.matchMedia("(max-width: 1024px)");
  const searchWrap = header.querySelector("[data-header-search]");
  const searchInput = header.querySelector("[data-header-search-input]");
  const searchToggle = header.querySelector("[data-header-search-toggle]");

  const isMobile = () => mobileQuery.matches;

  function openMenu() {
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("is-menu-open");
    menuButton.setAttribute("aria-expanded", "true");

    requestAnimationFrame(() => {
      header.classList.add("header--menu-open");
    });
  }

  function closeMenu() {
    if (!header.classList.contains("header--menu-open")) {
      return;
    }

    header.classList.remove("header--menu-open");
    menuButton.setAttribute("aria-expanded", "false");
    closeAllDrawerSubmenus();

    panel.addEventListener("transitionend", onCloseEnd);
  }

  function onCloseEnd(event) {
    if (event.target !== panel || event.propertyName !== "transform") {
      return;
    }

    panel.removeEventListener("transitionend", onCloseEnd);
    document.body.classList.remove("is-menu-open");
    drawer.setAttribute("aria-hidden", "true");
  }

  function expandDrawerSubmenu(item, toggle, collapse) {
    collapse.hidden = false;
    item.classList.add("is-open");
    toggle.setAttribute("aria-expanded", "true");
  }

  function collapseDrawerSubmenu(item, toggle, collapse) {
    if (!item.classList.contains("is-open")) return;

    item.classList.remove("is-open");
    toggle.setAttribute("aria-expanded", "false");

    collapse.addEventListener("transitionend", function onClose(event) {
      if (event.propertyName !== "grid-template-rows") return;

      if (!item.classList.contains("is-open")) {
        collapse.hidden = true;
      }

      collapse.removeEventListener("transitionend", onClose);
    });
  }

  function closeAllDrawerSubmenus() {
    submenuToggles.forEach((toggle) => {
      const item = toggle.closest(".header__drawer-item--has-children");
      const submenuId = toggle.getAttribute("aria-controls");
      const collapse = submenuId ? document.getElementById(submenuId) : null;
      if (!item || !collapse) return;
      collapseDrawerSubmenu(item, toggle, collapse);
    });
  }

  function toggleDrawerSubmenu(toggle) {
    const item = toggle.closest(".header__drawer-item--has-children");
    const submenuId = toggle.getAttribute("aria-controls");
    const collapse = submenuId ? document.getElementById(submenuId) : null;
    if (!item || !collapse) return;

    if (item.classList.contains("is-open")) {
      collapseDrawerSubmenu(item, toggle, collapse);
      return;
    }

    submenuToggles.forEach((other) => {
      if (other === toggle) return;
      const otherItem = other.closest(".header__drawer-item--has-children");
      const otherId = other.getAttribute("aria-controls");
      const otherCollapse = otherId ? document.getElementById(otherId) : null;
      if (!otherItem || !otherCollapse) return;
      collapseDrawerSubmenu(otherItem, other, otherCollapse);
    });

    expandDrawerSubmenu(item, toggle, collapse);
  }

  function closeDesktopDropdowns(except) {
    desktopItems.forEach((item) => {
      if (item === except) return;
      const link = item.querySelector(".header__nav-link");
      item.classList.remove("is-open");
      if (link) link.setAttribute("aria-expanded", "false");
    });
  }

  if (menuButton) {
    menuButton.addEventListener("click", openMenu);
  }

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeMenu);
  });

  drawerLinks.forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      toggleDrawerSubmenu(toggle);
    });
  });

  desktopItems.forEach((item) => {
    const link = item.querySelector(".header__nav-link");
    if (!link) return;

    link.addEventListener("click", (event) => {
      if (isMobile()) return;
      if (!item.querySelector(".header__dropdown")) return;

      event.preventDefault();
      const willOpen = !item.classList.contains("is-open");
      closeDesktopDropdowns(item);
      item.classList.toggle("is-open", willOpen);
      link.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
  });

  document.addEventListener("click", (event) => {
    if (isMobile()) return;
    if (header.contains(event.target) && event.target.closest(".header__nav-item--has-children")) {
      return;
    }
    closeDesktopDropdowns();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeMenu();
      closeDesktopDropdowns();
      if (searchInput && document.activeElement === searchInput) {
        searchInput.blur();
      }
      if (!isMobile()) {
        header.classList.remove("header--search-open");
        syncSearchAttrs(false);
      }
    }
  });

  function onViewportChange() {
    if (!isMobile()) {
      closeMenu();
    } else {
      closeDesktopDropdowns();
    }
    updateSearchVisibility();
  }

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", onViewportChange);
  } else if (typeof mobileQuery.addListener === "function") {
    mobileQuery.addListener(onViewportChange);
  }

  let lastScrollY = Math.max(0, window.scrollY);
  let scrollTicking = false;
  let ignoreScroll = false;
  const SEARCH_SCROLL_DELTA = 12;

  function syncSearchAttrs(isOpen) {
    if (searchWrap) searchWrap.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (searchToggle) searchToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    if (searchInput) searchInput.tabIndex = isOpen ? 0 : -1;
  }

  function setSearchHidden(hidden) {
    if (header.classList.contains("header--search-hidden") === hidden) return;

    ignoreScroll = true;
    header.classList.toggle("header--search-hidden", hidden);
    if (hidden) header.classList.remove("header--search-open");
    syncSearchAttrs(!hidden);
    lastScrollY = Math.max(0, window.scrollY);

    window.setTimeout(() => {
      lastScrollY = Math.max(0, window.scrollY);
      ignoreScroll = false;
    }, 360);
  }

  function updateSearchVisibility() {
    const y = Math.max(0, window.scrollY);

    if (!searchWrap) {
      syncSearchAttrs(false);
      lastScrollY = y;
      return;
    }

    if (!isMobile()) {
      header.classList.remove("header--search-hidden");
      syncSearchAttrs(header.classList.contains("header--search-open"));
      lastScrollY = y;
      return;
    }

    const isFocused = searchInput && document.activeElement === searchInput;
    if (isFocused) {
      header.classList.remove("header--search-hidden");
      syncSearchAttrs(true);
      lastScrollY = y;
      return;
    }

    if (ignoreScroll) {
      lastScrollY = y;
      return;
    }

    if (y <= 8) {
      setSearchHidden(false);
      lastScrollY = y;
      return;
    }

    const delta = y - lastScrollY;
    if (Math.abs(delta) < SEARCH_SCROLL_DELTA) return;

    setSearchHidden(delta > 0);
    lastScrollY = y;
  }

  function onSearchScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      updateSearchVisibility();
      scrollTicking = false;
    });
  }

  function toggleDesktopSearch() {
    const pageInput = document.querySelector(".collection__search-input");
    if (!searchWrap && pageInput) {
      pageInput.focus();
      if (typeof pageInput.select === "function") pageInput.select();
      return;
    }

    if (!searchInput) return;

    const isOpen = header.classList.contains("header--search-open");
    if (isOpen) {
      header.classList.remove("header--search-open");
      syncSearchAttrs(false);
      searchInput.blur();
      return;
    }

    header.classList.add("header--search-open");
    header.classList.remove("header--search-hidden");
    syncSearchAttrs(true);
    searchInput.focus();
  }

  window.addEventListener("scroll", onSearchScroll, { passive: true });

  if (searchToggle) {
    searchToggle.addEventListener("click", toggleDesktopSearch);
  }

  updateSearchVisibility();

  const marquee = header.querySelector(".header__marquee");

  function setupSaleMarquee() {
    if (!marquee || !(header.classList.contains("header--sale") || header.classList.contains("header--sale-bar"))) return;
    const first = marquee.querySelector(".header__announcement-text");
    if (!first) return;

    marquee.querySelectorAll("[data-marquee-clone]").forEach((node) => node.remove());

    if (!mobileQuery.matches) {
      marquee.classList.remove("is-running");
      marquee.style.removeProperty("--sale-marquee-shift");
      return;
    }

    const itemWidth = Math.round(first.getBoundingClientRect().width);
    if (!itemWidth) return;

    const view = marquee.parentElement ? marquee.parentElement.clientWidth : window.innerWidth;
    const needed = Math.max(2, Math.ceil((view + itemWidth) / itemWidth) + 1);
    const current = marquee.querySelectorAll(".header__announcement-text").length;

    for (let index = current; index < needed; index += 1) {
      const clone = first.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-marquee-clone", "true");
      marquee.appendChild(clone);
    }

    marquee.style.setProperty("--sale-marquee-shift", `${itemWidth}px`);
    marquee.classList.add("is-running");
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setupSaleMarquee);
  } else {
    setupSaleMarquee();
  }

  window.addEventListener("resize", setupSaleMarquee);
})();
